import script from "./CustomerRevenueReport.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerRevenueReport.vue?vue&type=script&setup=true&lang=js"

import "./CustomerRevenueReport.vue?vue&type=style&index=0&id=584b3684&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584b3684"]])

export default __exports__

/* vue-cli-plugin-import-components */

import BasicSpinner from "@/components/BasicSpinner.vue";
import CustomerProductsOrdered from "@/components/customers/CustomerProductsOrdered.vue";
import ReportChart from "@/components/reports/ReportChart.vue";
import ReportDateRangeFilter from "@/components/reports/ReportDateRangeFilter.vue";
import RevenuePeriodTable from "@/components/customers/RevenuePeriodTable.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import StatTile from "@/components/customers/record/StatTile.vue";
script.components = Object.assign({}, { BasicSpinner, CustomerProductsOrdered, ReportChart, ReportDateRangeFilter, RevenuePeriodTable, SelectInput, StatTile }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicSpinner, CustomerProductsOrdered, ReportChart, ReportDateRangeFilter, RevenuePeriodTable, SelectInput, StatTile }, script.__o.components);}